import { NgModule } from '@angular/core';
import {RouterModule, Routes} from "@angular/router";
import {TalentProfileContainerComponent} from "./talent-profile-container/talent-profile-container.component";

const routes: Routes = [
  {
    path: '',
    component: TalentProfileContainerComponent
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TalentProfileRoutingModule {
}
